export const schoolOfficerPaymentRoutes = [
  {
    path: "/schoolofficerpayment",
    component: () =>
      import("@/views/SchoolOfficerPayment/SchoolOfficerPaymentDisplay.vue"),
  },
  // {
  //   path: "/schoolofficerpayment/details",
  //   component: () => import("@/views/SchoolOfficerPayment/Create.vue"),
  // },
  {
    path: "/schoolofficerpayment/paymentdetails",
    component: () =>
      import("@/views/SchoolOfficerPayment/SchoolOfficerPayment.vue"),
  },
  {
    path: "/schoolofficerpayment/paymentlist/",
    component: () =>
      import("@/views/SchoolOfficerPayment/SchoolOfficerPaymentList.vue"),
  },

  {
    path: "/schoolofficerpayment/transactions/",
    component: () =>
      import("@/views/SchoolOfficerPayment/TransactionsList.vue"),
  },
];
